import { Box, Button, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { deleteInvoices } from '../../../../api/invoicing';
import { getInvoices } from '../../../../redux/slices/invoicing';
import { useDispatch, useSelector } from '../../../../redux/store';
import { ConfirmDialog } from '../../../../reusable-components/confirm-dialog';
import Iconify from '../../../../reusable-components/iconify/Iconify';
import { useSnackbar } from '../../../../reusable-components/snackbar';
import { markMetricRemoved, NotificationMetricType } from '../../../../redux/slices/notifications';

ProcessManualInvoices.propTypes = {
  setShowSelection: PropTypes.func.isRequired,
  showSelection: PropTypes.string.isRequired,
  setIsLoading: PropTypes.func.isRequired
};

export default function ProcessManualInvoices({ setShowSelection, showSelection, setIsLoading }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const section = location.pathname.split('/').pop();

  const {
    data: { manualInvoicing, pendingInvoicing, pendingFilterInvoicing },
  } = useSelector((state) => state.invoicing);
  const { enqueueSnackbar } = useSnackbar();

  const currentInvoices =
    section === 'new' ? manualInvoicing : section === 'pendingFilter' ? pendingFilterInvoicing : pendingInvoicing;
  const invoicesInQueue = JSON.parse(localStorage.getItem('selectedInvoices')) || [];
  const selectedInvoiceNumbers = invoicesInQueue.map((id) => {
    const invoice = currentInvoices?.find((currentInvoice) => currentInvoice.id === id);
    return invoice?.vendorInvoiceId || `Invoice ID ${id}`;
  });

  const handleDelete = async () => {
    setIsLoading(true);
    const ids = invoicesInQueue;
    const response = await deleteInvoices(ids);
    setShowSelection('')
    if (response.status === 200) {
      enqueueSnackbar('Invoices deleted successfully', { variant: 'success' });
      dispatch(markMetricRemoved(NotificationMetricType.InvoicesSubmitted, ids));
      dispatch(markMetricRemoved(NotificationMetricType.InvoicesNeedApproval, ids));
      localStorage.removeItem('selectedInvoices');
      dispatch(getInvoices()).then(() => {
        setIsLoading(false);
      });
    }
    else setIsLoading(false)
  };

  const processInvoices = async () => {
    const nextId = JSON.parse(localStorage.getItem('selectedInvoices'))[0];
    navigate(`/dashboard/invoicing/${section}/${nextId}`);
    setShowSelection('');
  };

  const cancel = () => {
    localStorage.removeItem('selectedInvoices');
    setShowSelection('');
  };
  return (
    <>
      {currentInvoices?.length > 0 && (
        <>
          {showSelection !== 'Select invoices' ? (
            <>
              <Button
                size="small"
                onClick={() => {
                  setShowSelection('Select invoices');
                }}
                variant="contained"
                color="secondary"
                startIcon={<Iconify icon="ph:check-fill" />}
              >
                Select Invoices
              </Button>
            </>
          ) : (
            <>
              <Button
                variant="contained"
                size="small"
                sx={{ mr: 1, pr: 5, pl: 5 }}
                color="secondary"
                disabled={invoicesInQueue?.length === 0}
                onClick={() => {
                  processInvoices();
                }}
              >
                Process
              </Button>
              <ConfirmDialog
                button="outlined"
                color="secondary"
                title="Delete invoices"
                actionButton="Delete"
                disabled={invoicesInQueue?.length === 0}
                buttonStyles={{ mr: 1 }}
                content={(
                  <>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      Are you sure you want to delete these invoices?
                    </Typography>
                    <Box component="ul" sx={{ pl: 2, mb: 0 }}>
                      {selectedInvoiceNumbers.map((invoiceNumber, index) => (
                        <Box component="li" key={`${invoiceNumber}-${index}`}>
                          {invoiceNumber}
                        </Box>
                      ))}
                    </Box>
                  </>
                )}
                action={handleDelete}
              />
              <Button size="small" sx={{ mr: 1, textDecoration: 'underline' }} color="secondary" onClick={cancel}>
                Cancel
              </Button>
            </>
          )}
        </>
      )}
    </>
  );
}
